import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { FaDiscord } from "react-icons/fa";
import { CaretDownOutlined, GlobalOutlined } from "@ant-design/icons";
import { LanguageContext } from "./LanguageContext";
import { AppBar, Toolbar, Typography, Button, Menu, MenuItem, IconButton, useMediaQuery, useTheme } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import { navMenus } from "../config/appRoutes";

const MENU_KEYS = {
  tool: "Tool",
  jobHunt: "JobHunt",
  contact: "Contact",
  language: "Language",
};

const menuSections = [
  { key: MENU_KEYS.tool, label: "Tool", items: navMenus.tool },
  { key: MENU_KEYS.jobHunt, label: "JobHunt", items: navMenus.jobHunt },
  { key: MENU_KEYS.contact, label: "Contact", items: navMenus.contact },
];

function Header() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const [currentDropdown, setCurrentDropdown] = useState("");
  const { setLanguage } = useContext(LanguageContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleMenuClick = (event, menu) => {
    if (currentDropdown === menu && Boolean(anchorEl)) {
      setAnchorEl(null);
      setCurrentDropdown("");
    } else {
      setAnchorEl(event.currentTarget);
      setCurrentDropdown(menu);
    }
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMobileMoreAnchorEl(null);
    setCurrentDropdown("");
  };

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    handleMenuClose();
  };

  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
    >
      {menuSections
        .find((section) => section.key === currentDropdown)
        ?.items.map((item) => (
          <MenuItem
            key={item.path}
            component={item.external ? "a" : Link}
            href={item.external ? item.path : undefined}
            to={item.external ? undefined : item.path}
            onClick={handleMenuClose}
          >
            {item.label}
          </MenuItem>
        ))}
      {currentDropdown === MENU_KEYS.language && (
        <>
          <MenuItem onClick={() => handleLanguageChange("CN")}>Chinese</MenuItem>
          <MenuItem onClick={() => handleLanguageChange("EN")}>English</MenuItem>
          <MenuItem onClick={() => handleLanguageChange("JP")}>Japanese</MenuItem>
        </>
      )}
    </Menu>
  );

  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      open={Boolean(mobileMoreAnchorEl)}
      onClose={handleMenuClose}
    >
      {menuSections.map((section) => (
        <MenuItem key={section.key} onClick={(e) => handleMenuClick(e, section.key)}>
          {section.label}
        </MenuItem>
      ))}
      <MenuItem onClick={(e) => handleMenuClick(e, MENU_KEYS.language)}>Language</MenuItem>
    </Menu>
  );

  return (
    <AppBar position="fixed" sx={{ background: "#333", zIndex: 100000, height: "0px" }}>
      <Toolbar sx={{ justifyContent: "space-between", minHeight: "64px" }}>
        <Typography
          component={Link}
          to="/"
          sx={{
            textDecoration: "none",
            color: "#fff",
            fontWeight: "bold",
            fontSize: "1.2rem"
          }}
        >
          Gpt-Work
        </Typography>

        {isMobile ? (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleMobileMenuOpen}
          >
            <MenuIcon />
          </IconButton>
        ) : (
          <div>
            {menuSections.map((section) => (
              <Button
                key={section.key}
                color="inherit"
                onClick={(e) => handleMenuClick(e, section.key)}
                sx={{ textTransform: "none", mr: 2 }}
              >
                {section.label} {section.key === MENU_KEYS.contact ? <FaDiscord /> : <CaretDownOutlined />}
              </Button>
            ))}
            <Button
              color="inherit"
              onClick={(e) => handleMenuClick(e, MENU_KEYS.language)}
              sx={{ textTransform: "none" }}
            >
              Language <GlobalOutlined />
            </Button>
          </div>
        )}
      </Toolbar>
      {renderMenu}
      {renderMobileMenu}
    </AppBar>
  );
}

export default Header;
